// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRemainderDto
 */
export interface IRemainderDto {
    /**
     * 
     * @type {string}
     * @memberof IRemainderDto
     */
    destination_type?: IRemainderDtoDestinationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IRemainderDto
     */
    remainder_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IRemainderDto
     */
    benefit_of?: string;
    /**
     * 
     * @type {string}
     * @memberof IRemainderDto
     */
    pay_to?: string;
    /**
     * 
     * @type {string}
     * @memberof IRemainderDto
     */
    address_line1?: string;
    /**
     * 
     * @type {string}
     * @memberof IRemainderDto
     */
    address_line2?: string;
    /**
     * 
     * @type {string}
     * @memberof IRemainderDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof IRemainderDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof IRemainderDto
     */
    zip?: string;
    /**
     * 
     * @type {number}
     * @memberof IRemainderDto
     */
    account_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IRemainderDtoDestinationTypeEnum {
    PLAN_ACCOUNT = 'PLAN_ACCOUNT',
    CHECK = 'CHECK'
}


/**
 * Check if a given object implements the IRemainderDto interface.
 */
export function instanceOfIRemainderDto(value: object): value is IRemainderDto {
    return true;
}

export function IRemainderDtoFromJSON(json: any): IRemainderDto {
    return IRemainderDtoFromJSONTyped(json, false);
}

export function IRemainderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRemainderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'destination_type': json['destination_type'] == null ? undefined : json['destination_type'],
        'remainder_amount': json['remainder_amount'] == null ? undefined : json['remainder_amount'],
        'benefit_of': json['benefit_of'] == null ? undefined : json['benefit_of'],
        'pay_to': json['pay_to'] == null ? undefined : json['pay_to'],
        'address_line1': json['address_line1'] == null ? undefined : json['address_line1'],
        'address_line2': json['address_line2'] == null ? undefined : json['address_line2'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
    };
}

export function IRemainderDtoToJSON(json: any): IRemainderDto {
    return IRemainderDtoToJSONTyped(json, false);
}

export function IRemainderDtoToJSONTyped(value?: IRemainderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'destination_type': value['destination_type'],
        'remainder_amount': value['remainder_amount'],
        'benefit_of': value['benefit_of'],
        'pay_to': value['pay_to'],
        'address_line1': value['address_line1'],
        'address_line2': value['address_line2'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'account_id': value['account_id'],
    };
}

